import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import { Form, FormGroup, Label, Input, Row, Col, Card, CardBody, Container } from 'reactstrap';
import DownloadImg from '../../Assets/images/icons/downloadicon.png';
import { useDropzone } from 'react-dropzone';
import { formatBytes } from '../../Common';
import { createBanner } from '../../API/Backend';
import { showToast } from "../../Components/Toast"

const AddBanner = () => {
  const [bannerName, setBannerName] = useState('');
  const [bannerFile, setBannerFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ bannerName: "", bannerFile: "", previewUrl: "" });
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
  const ALLOWED_FORMATS = ['jpg', 'jpeg', 'png'];
  const history = useNavigate();

  // const onDrop = useCallback((acceptedFiles) => {
  //   const file = acceptedFiles[0];
  //   if (file) {
  //     setBannerFile(file);
  //     const preview = URL.createObjectURL(file);
  //     setPreviewUrl(preview);
  //   }
  // }, []);
  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];

    setErrors({ bannerFile: "", previewUrl: "" });

    if (!file) {
      setErrors({ bannerFile: "No file selected." });
      setBannerFile(null);
      setPreviewUrl(null);
      return;
    }

    const fileExt = file.name.split('.').pop().toLowerCase();
    if (!ALLOWED_FORMATS.includes(fileExt)) {
      setErrors({ bannerFile: "Only jpg, jpeg, png files are allowed." });
      setBannerFile(null);
      setPreviewUrl(null);
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      setErrors({ bannerFile: "File size should be less than 5MB." });
      setBannerFile(null);
      setPreviewUrl(null);
      return;
    }

    const formattedFiles = [file].map(f =>
      Object.assign(f, {
        formattedSize: formatBytes(f.size),
        preview: URL.createObjectURL(f),
      })
    );

    setBannerFile(formattedFiles[0]);
    setPreviewUrl(formattedFiles[0].preview);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    // accept: {
    //   'image/jpeg': ['.jpeg', '.jpg'],
    //   'image/png': ['.png']
    // },
    multiple: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    let flag = false;
    let error = { bannerName: "", bannerFile: "", previewUrl: "" };
    if (!bannerName || bannerName.replace(/\s/g, '').length < 1) {
      flag = true;
      error.bannerName = "Please provide a valid name";
    }
    if (!bannerFile) {
      flag = true;
      error.bannerFile = "Please provide a valid file for banner";
    }
    setErrors(error)
    if (!flag) {
      setLoading(true);
      const formData = new FormData();
      formData.append("title", bannerName);
      formData.append("image", bannerFile);
      formData.append(`status`, "true");
      createBanner(formData).then((data) => {
        if (data.data.success) {
          showToast("success", "Banner Created", "Your new banner has been created successfully.")
          setLoading(false);
          history('/banners')
        }
        else {
          showToast("error", "Banner Request Failed", "Your new banner could not be created.")
          setLoading(false);
        }
      }).catch((e) => {
        showToast("error", "Banner Request Failed", "Your new banner could not be created.")
        setLoading(false);
      })
    }
  };
  return (
    <Container fluid>
      <Row>
        <Col>
          <h4 className="fw-600 fs-18 mb-4">Add Banner</h4>
          <Card>
            <CardBody>
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Input
                    type="text"
                    id="bannerName"
                    placeholder="Enter Banner Name"
                    value={bannerName}
                    onChange={(e) => setBannerName(e.target.value)}
                  />
                  {errors.bannerName && <div className="text-danger fs-12 mt-2">{errors.bannerName}</div>}
                </FormGroup>
                <FormGroup>
                  <div
                    {...getRootProps()}
                    className="text-center my-4 border p-4 rounded"
                    style={{
                      borderStyle: 'dashed',
                      cursor: 'pointer',
                      backgroundColor: '#f9f9f9'
                    }}
                  >
                    <input {...getInputProps()} />
                    {previewUrl ? (
                      <img
                        src={previewUrl}
                        alt="Preview"
                        style={{
                          width: '100%',
                          maxHeight: '200px',
                          objectFit: 'cover',
                          borderRadius: '6px',
                        }}
                      />
                    ) : (
                      <div>
                        <img src={DownloadImg} alt="Upload Icon" />
                        <p className="fs-14 fw-400">
                          {isDragActive ? 'Drop the image here...' : 'Upload Banner'}
                        </p>
                      </div>
                    )}
                  </div>
                  {errors.bannerFile && <div className="text-danger fs-12">{errors.bannerFile}</div>}
                </FormGroup>

                <div className="text-end">
                  <button disabled={loading} type="submit" className="btn btn-primary">
                    {loading ? "Please Wait" : "Submit"}
                  </button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddBanner;
